import { Inject, Injectable, InjectionToken } from '@angular/core';
import { DataGridColumn, SortObject, DataGridEvent, DGMenuItem, StatusBarSummaryData, CellChangeEvent } from '../components/datagrid/datagrid.component';
import { FormItem, FormSubmitFields, TabItem } from '../components/form/FormItem';
import { ButtonBarItem } from '../components/buttonbar/buttonbar.component';
import { GlobalsService } from './globals.service';

// import * as purchasing from 'src/app/purchasing/purchasing-page-meta';

export enum ResponseFieldDataSourceType {
  datagridDataSource,
  datagridFilterDataSource,
  pageGeneralDataSource,
  formDataSource,
  formFieldDataSource,
  currencyDataSource,
}

export interface ResponseField {
  fieldName: string;
  responseFieldType: ResponseFieldDataSourceType;
  componentName?: string;
  isKeyValuePair?: boolean;
  connectedComponentName?: string;
}
export interface PassedData {
  datagridField: string;
  dbQueryField: string;
  value?: string;
}
export interface PageMeta {
  // bu calisinca, page meta icinden dolacak
  snapShotData?: any;

  listPageName?: string;
  editPageName?: string;
  // tanımlanan pid ve aid ler ile sayfa adı uyumsuz ise
  listPageLabel?: string;
  editPageLabel?: string;

  pid: number;
  // eger list page baska edit page baska ise boyle birsey yaptik
  editPid?: number;

  // bu sayfadan baska sayfaya secim yapilacak mi?
  hasSelectButton?: boolean;
  // bu sayfanin datagrid coktan secmeli checkbox olacak mi?
  hasMultiSelectDataGrid?: boolean;
  enableCharts?: boolean;

  listAid?: number; // 0 list sayfasi
  inspectAid?: number; // 1 yani sayfa editte acilirken
  addAid?: number; // 2 yani sayfa ekleme butonuna basinca
  editAid?: number; // 3 yani sayfada guncelle butonuna basinca
  deleteAid?: number; // 4 yani silme butonu
  rowClassRules?: any;
  // burasi belki kullanmilmayacak
  listChildrenAid?: number;
  addChildAid?: number;
  editChildAid?: number;
  deleteChildAid?: number;

  hasButtonBarInList?: boolean;
  hasButtonBarInEdit?: boolean;

  dataGridColumns?: DataGridColumn[];
  datagridOptions?: {};

  dataGridInitialSort?: SortObject;

  // list icin alanlar
  pageNoField?: string;
  pageTotalsField?: string;
  responseFields?: ResponseField[];
  datagridHasAddBtn?: boolean;
  datagridHasEditBtn?: boolean;
  datagridEditBtnText?: string;
  datagridHasDeleteBtn?: boolean;
  // dg ilk yuklendiginde bos gelince verdigi hata
  // orn. once proje secin
  datagridFirstLoadError?: string;

  datagridContextMenuItems?: (string | DGMenuItem)[];
  datagridSideMenuItems?: ButtonBarItem[];
  datagridStatusBarItems?: StatusBarSummaryData[];

  datagridSelectBtnClickHandler?: (event: DataGridEvent) => void;
  datagridDoubleClickHandler?: (event: DataGridEvent) => void;
  datagridCellChangeHandler?: (event: CellChangeEvent) => void;

  // sayfa ilk acilirken, data icinde viasResponse service e gidecek sabit degerler
  initDataFields?: {}; // list
  editInitDataFields?: {}; // edit
  initDataFieldsFunction?: () => {};
  // sayfa ilk acilirken, data icinde viasResponse service e gidecek sabit degerler
  initDataFieldsForFilterObject?: {};

  // form acildiginda disabled acilan alanlar icin fonksiyon
  // disabledOnInspect olanlari kapatacak fonksiyon
  formDisableFunctionOnLoad?: () => boolean;

  // datagrid edit basinca orn. list 1 gibi durumlarda,
  // bu alanlarda yazanlar gonderilecek
  passedDataFields?: PassedData[];


  // form icin alanlar
  formItems?: FormItem[];
  formSubmitFields?: FormSubmitFields[];
  tabs?: string[] | TabItem[];
  tabSelectedIndex?: number;
  hasSubmitBtn?: boolean;
  submitBtnText?: string;
  submitAid?: number;
  // Belirtilen form item change olduğunda çalışacak
  formChangeFunctionItems?: string[];
  formChangeFunction?: (...args) => void;
  formBeforeSubmitFunction?: (...args) => void;
  formAfterSubmitFunction?: (...args) => void;
  // Buttonbar
  buttonBarItems?: ButtonBarItem[];
}
export const PAGEMETA_PROVIDER = new InjectionToken<any>('PageMeta Provider', {
  providedIn: 'root',
  factory: () => { }
});
@Injectable({
  providedIn: 'root',
  // useFactory: () => {
  //    return new purchasing.MaterialsPageMeta();
  // }
})
export class PageMetaService {
  // constructor( @Inject(PAGEMETA_PROVIDER) private pageMetaDef: any) {}
  constructor() { }
  // public loadPageMeta(pageName: string): PageMeta {
  //   return new this.pageMetaDef[pageName]();
  // }

  // getInstance(name: string, ...args: any[]) {
  //     var instance = Object.create(this.context[name].prototype);
  //     instance.constructor.apply(instance, args);
  //     return instance;
  // }

  getPage(uri: string, moduleName: string, pageName: string): Promise<PageMeta> {
    return new Promise((resolve, reject) => {
      console.log('1!!!!!!!', `${uri}/${moduleName}/${moduleName}-page-meta.ts`);
      import(`${uri}/${moduleName}/${moduleName}-page-meta`).then(
        res => {
          // console.log(res);
          resolve(new res.PageMetaDefs[pageName]());
        },
        err => {
          console.log('hahahahahaha', err);
          reject(err);
        }
      );
    });
    return null;
  }
}
